import { Button } from "@overmap-ai/blocks"
import type { Column } from "@tanstack/react-table"
import { type ComponentPropsWithRef, type MouseEventHandler, useCallback } from "react"

import { genericMemo } from "../../../utils/optimization"

interface ColumnSortButtonProps<TData> extends ComponentPropsWithRef<typeof Button> {
	column: Column<TData>
}

export const ColumnSortButton = genericMemo(function ColumnSortDropdown<TData>(props: ColumnSortButtonProps<TData>) {
	const { children, ref, onClick, column, ...rest } = props

	const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			onClick?.(e)
			if (e.defaultPrevented) return
			column.toggleSorting()
		},
		[column, onClick],
	)

	return (
		<Button ref={ref} onClick={handleClick} {...rest}>
			{children}
		</Button>
	)
})
